import { Alert, Stack, Typography } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';

function RouteComponent() {
  return (
    <Alert color="success" sx={{ marginTop: 2 }}>
      <Stack alignItems="center" gap={2}>
        <Typography level="h3">Vielen Dank für Ihre Eingabe.</Typography>

        <Typography>Wir informieren den/die Bearbeiter*in für die abschließende Prüfung</Typography>
      </Stack>
    </Alert>
  );
}

export const Route = createFileRoute('/_authenticated/anordnung/success')({
  component: RouteComponent,
});
